import * as TWEEN from "@tweenjs/tween.js"
import { Graphics, Sprite, Point } from "pixi.js"
import { TwistFilter, RadialBlurFilter } from "pixi-filters"
import portal from "./portal.png"
import { isMobile } from "react-device-detect"

export class BlackHole {
  starContainer = null
  container = null
  init() {
    this.circleHolder = new Sprite()
    this.circleHolder.anchor.set(0.5, 0.5)
    // this.circleHolder.scale.set(1, 1)
    // this.starContainer.scale.set(1, 1)
  }

  getBlackHoleResourses = () => {
    return [["portal", portal]]
  }

  setContainerForBlackHole = (container, app) => {
    this.init(app)

    this.starContainer = app.stage.getChildByName("starContainer")
    this.container = container
    this.circleHolder.scale.set(1, 1)
    this.starContainer.scale.set(1, 1)
    container.addChild(this.circleHolder)
  }

  startBlackHole = () => {
    this.circle = Sprite.from("portal")
    this.circle.anchor.set(0.5, 0.5)
    this.circle.scale.set(0.01, 0.01)
    this.circleHolder.addChild(this.circle)
    this.circle2 = new Graphics()

    this.circle2.beginFill(0x000000)
    this.circle2.drawCircle(0, 0, 900)
    this.circle2.endFill()
    this.circle.addChild(this.circle2)
    setTimeout(() => {
      var filter = new TwistFilter({
        radius: isMobile ? 200 : 400,
        angle: 10,
        padding: 0,
        offset: { x: this.starContainer.x, y: this.starContainer.y + 50 },
      })
      var offsetY = this.starContainer.y - this.container.y
      this.circleHolder.x = 0
      this.circleHolder.y = offsetY
      this.circleHolder.alpha = 1
      this.circleHolder.scale.set(1, 1)
      this.starContainer.filters = [filter]
      this.starContainer.alpha = 1
      this.starContainer.scale.set(1, 1)

      new TWEEN.Tween(this.circle.scale)
        .to({ x: 0.3, y: 0.3 }, 4500)
        .easing(TWEEN.Easing.Linear.None)
        .start()
    }, 500)
  }

  hideBlackHole = () => {
    this.starContainer.filters = []
    new TWEEN.Tween(this.circleHolder)
      .delay(1000)
      .to({ alpha: 0, scale: { x: 0, y: 0 } }, 500)
      .easing(TWEEN.Easing.Linear.None)
      .start()

    new TWEEN.Tween(this.starContainer)
      .delay(1000)
      .to({ alpha: 0, scale: { x: 0, y: 0 } }, 500)
      .easing(TWEEN.Easing.Linear.None)
      .start()

      .onComplete(
        () => (
          this.circle.removeChild(this.circle2),
          this.circleHolder.removeChild(this.circle)
        ),
      )
  }
}
